var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2341 1.40059L4.65078 8.98392C4.45345 9.18824 4.34425 9.46189 4.34672 9.74594C4.34919 10.03 4.46312 10.3017 4.66398 10.5026C4.86484 10.7034 5.13655 10.8173 5.4206 10.8198C5.70465 10.8223 5.9783 10.7131 6.18262 10.5158L11.9167 4.78167L11.9167 23.8332C11.9167 24.1205 12.0308 24.396 12.234 24.5992C12.4372 24.8024 12.7127 24.9165 13 24.9165C13.2874 24.9165 13.5629 24.8024 13.7661 24.5992C13.9692 24.396 14.0834 24.1205 14.0834 23.8332L14.0834 4.78167L19.8175 10.5158C19.9174 10.6192 20.0369 10.7018 20.1691 10.7585C20.3013 10.8153 20.4434 10.8452 20.5873 10.8464C20.7311 10.8477 20.8738 10.8203 21.0069 10.7658C21.14 10.7113 21.261 10.6309 21.3627 10.5292C21.4644 10.4275 21.5449 10.3065 21.5993 10.1734C21.6538 10.0402 21.6812 9.89758 21.68 9.75374C21.6787 9.60989 21.6488 9.46774 21.5921 9.33557C21.5353 9.2034 21.4528 9.08385 21.3493 8.98392L13.766 1.40059C13.5628 1.19749 13.2873 1.0834 13 1.0834C12.7128 1.0834 12.4373 1.19749 12.2341 1.40059Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/top-arrow.710f074ab32ed3c061907bb0032a53c4.svg";
export { ForwardRef as ReactComponent };